import React from "react";

export const FacilitySvg = ({pathNames}) => {
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          stroke={
            pathNames?.toLowerCase()?.includes("facility")
              ? "#ffffff"
              : "#667085"
          }
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M15 1.667H5c-.92 0-1.667.746-1.667 1.666v13.334c0 .92.747 1.666 1.667 1.666h10c.92 0 1.667-.746 1.667-1.666V3.333c0-.92-.747-1.666-1.667-1.666" />
          <path d="M7.5 18.333V15h5v3.333M6.667 5h.008m6.658 0h.009M10 5h.008M10 8.333h.008M10 11.667h.008m3.325-3.334h.009m-.009 3.334h.009M6.667 8.333h.008m-.008 3.334h.008" />
        </g>
      </svg>
    </div>
  );
};
